/**
 * Local/Session Storage Utility
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var urlUtil = require('util/url.util');
    var config = require('config');

    window.memoryStorage = {
        _data: {},
        setItem: function(id, val) { return this._data[id] = String(val); },
        getItem: function(id) {
            return Object.prototype.hasOwnProperty.call(this._data, id)
                ? this._data[id]
                : undefined;
        },
        removeItem: function(id) { return delete this._data[id]; },
        clear: function() { return this._data = {}; }
    };

    var _storage = {
        _getItem: function(key) {
            var value;

            try {
                value = window[this._name].getItem(key);
                value = JSON.parse(value);
            } catch (e) {
                window.console.warn('`localStorage` getItem is unavailable');
            }

            return value;
        },

        _setItem: function(key, value) {
            value = JSON.stringify(value);

            try {
                window[this._name].setItem(key, value);
            } catch (e) {
                window.console.warn('`localStorage` is full, don\'t set anything');
            }
        },

        _removeItem: function(key) {
            window[this._name].removeItem(key);
        },

        _clear: function(pattern) {
            if (pattern) {
                for (var item in window[this._name]) {
                    if (item.match(pattern)) {
                        window[this._name].removeItem(item);
                    }
                }
            } else {
                window[this._name].clear();
            }
        },

        _key: function(index) {
            return window[this._name].key(index);
        },

        _size: function() {
            return window[this._name].length;
        }
    };

    var storage = {

        local: {
            _name: (function() {
                try {
                    window.localStorage.setItem('localStorage is supported', true);
                    window.localStorage.removeItem('localStorage is supported');
                    return 'localStorage';
                } catch (e) {
                    return 'memoryStorage';
                }
            })(),

            /**
             * @deprecated 20.4.1.0
             * Use `fetch` for the same functionality (util/fetch.util)
             */
            getData: function(options) {
                var localKey = options.url;
                var status = $.Deferred();

                if (options.data instanceof Object) {
                    localKey += '?' + urlUtil.serialize(options.data);
                }

                var data = this.getItem(localKey);

                if (data) {
                    options.success && options.success(data);
                    status.resolve(data);
                } else {
                    options.data = options.data || {};

                    $.extend(options.data, urlUtil.getURLParams(), {
                        t: this.getItem('userModel') && this.getItem('userModel').role === 'admin'
                            ? Date.now()
                            : config.get('requestStamp')
                    });

                    // this parameter should not be passed at all
                    delete options.data.js_fast_load;

                    var originSuccess = options.success;

                    options.success = function(resp) {
                        this.setItem(localKey, resp);
                        originSuccess && originSuccess(resp);
                    }.bind(this);

                    return $.ajax(options);
                }

                return status;
            },

            getItem: function(key) { // eslint-disable-line
                return _storage._getItem.apply(this, arguments);
            },

            setItem: function(key, value) { // eslint-disable-line
                _storage._setItem.apply(this, arguments);
            },

            removeItem: function(key) { // eslint-disable-line
                _storage._removeItem.apply(this, arguments);
            },

            clear: function(pattern) { // eslint-disable-line
                _storage._clear.apply(this, arguments);
            },

            key: function(index) { // eslint-disable-line
                return _storage._key.apply(this, arguments);
            },

            size: function() {
                return _storage._size.apply(this);
            }
        }
    };

    storage.session = $.extend({}, storage.local);
    storage.session._name = (function() {
        try {
            window.sessionStorage.setItem('sessionStorage is supported', true);
            window.sessionStorage.removeItem('sessionStorage is supported');
            return 'sessionStorage';
        } catch (e) {
            return 'memoryStorage';
        }
    })();

    module.exports = storage;
});
